export const digitPattern = /^\d+(?:[.,]\d+)?$/;
